import { useCallback } from "react"
import type { AnySchema } from "yup"
import { isProd } from "../config"

export const useYupValidationResolver = (validationSchema: AnySchema) =>
  useCallback(
    async (data: any) => {
      !isProd &&
        console.debug("> useYupValidationResolver.callback: data =", data)
      // special case handling for GroupMask
      if ("address" in data && "gps" in data.address) {
        if (!data.address.gps?.latitude || !data.address.gps?.longitude) {
          data.address.gps = null
        }
      }
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        })

        !isProd && console.log("< resolver callback: validated")
        return {
          values,
          errors: {},
        }
      } catch (errors: any) {
        !isProd && console.error("< resolver callback: error", errors)
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors: any, currentError: any) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? "validation",
                message: currentError.message,
              },
            }),
            {}
          ),
        }
      }
    },
    [validationSchema]
  )
